import React from 'react';
import PropTypes from 'prop-types';
import { PermissionContext } from '../../hoc/withPermission';
import UserIcon from '../../common/data-display/UserIcon';
import Tag from 'components/layout/Tag';
import { ACTIVE_CURRICULUM_STATUS, API_HOST } from '../../consts';
import { get } from 'lodash';

const statusColor = (status_id = ACTIVE_CURRICULUM_STATUS) =>
  status_id === ACTIVE_CURRICULUM_STATUS ? '#3f928b' : '#b77474';

const PreMatriculadoCard = ({
  person_id,
  photo_url,
  student_curriculum_id,
  usuario,
  children,
}) => {
  const { status } = usuario;

  return (
    <PermissionContext.Consumer>
      {() => (
        <div className="usuario-card">
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center flex-direction-column">
              <UserIcon
                src={photo_url}
                className="img-user-72"
                alt={usuario?.student?.name}
              />
              {status && (
                <Tag
                  className="mt-2"
                  backgroundColor={statusColor(usuario.status)}
                >
                  {usuario.status_name}
                </Tag>
              )}
            </div>
            <div className="ml-3">{children}</div>
          </div>
        </div>
      )}
    </PermissionContext.Consumer>
  );
};

PreMatriculadoCard.propTypes = {
  usuario: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  photo_url: PropTypes.string,
  person_id: PropTypes.number,
  student_curriculum_id: PropTypes.number,
};

PreMatriculadoCard.defaultProps = {
  photo_url: null,
  person_id: null,
  student_curriculum_id: null,
};

export default PreMatriculadoCard;
